import { TToastData } from 'components/system/Toast/toast.types';

export const uploadingToastProps: TToastData = {
  type: 'loading',
  title: 'Uploading file',
  description: 'File upload is in progress...',
  loadingVariant: 'indeterminate',
};

export const successfulToastProps: TToastData = {
  type: 'success',
  title: 'Upload successful',
  description: 'Upload completed successfully',
};

export const canceledToastProps: TToastData = {
  type: 'info',
  title: 'Upload Canceled',
  description: 'The file upload was canceled',
};

export const errorToastProps: TToastData = {
  type: 'error',
  title: 'Upload Error',
  description: 'Error uploading file, please try again',
};
